export type AlertLevel = 'critical' | 'warning' | 'watch' | 'info'

export type LevelMeta = {
  label: string
  color: string
  soft: string
  glow: string
}

export const levelMeta: Record<AlertLevel, LevelMeta> = {
  critical: { label: '紧急', color: 'var(--critical)', soft: 'var(--critical-soft)', glow: 'glow-critical' },
  warning: { label: '警戒', color: 'var(--warning)', soft: 'var(--warning-soft)', glow: 'glow-warning' },
  watch: { label: '关注', color: 'var(--watch)', soft: 'var(--watch-soft)', glow: 'glow-watch' },
  info: { label: '信息', color: 'var(--info)', soft: 'var(--info-soft)', glow: '' },
}

/** 后端 alertLevel（BE_AWARE / TAKE_ACTION）或 severity(1-5) → 展示色阶 */
export function toAlertLevel(alertLevel?: string | null, severity?: number | null): AlertLevel {
  if (alertLevel === 'TAKE_ACTION') return 'critical'
  if (alertLevel === 'BE_AWARE') return 'warning'
  if (severity != null) {
    if (severity >= 4) return 'critical'
    if (severity >= 3) return 'warning'
    if (severity >= 2) return 'watch'
  }
  return 'info'
}

export const eventTypeMeta: Record<string, { label: string }> = {
  earthquake: { label: '地震' },
  fire: { label: '火灾' },
  flood: { label: '洪涝' },
  landslide: { label: '滑坡' },
  weather: { label: '气象' },
  weather_anomaly: { label: '气象异常' },
  traffic: { label: '交通' },
  composite: { label: '复合' },
  other: { label: '其他' },
}

export function eventTypeLabel(type?: string | null): string {
  if (!type) return '未知'
  return eventTypeMeta[type]?.label ?? type
}

export const eventStatusLabel: Record<string, string> = {
  pending: '确认中',
  confirmed: '已确认',
  closed: '已关闭',
}
